module.exports = __webpack_public_path__ + "static/media/SE_reading.8f463812.mp4";